import { render, staticRenderFns } from "./InventoryShort.vue?vue&type=template&id=1eaf8fa6"
import script from "./InventoryShort.vue?vue&type=script&lang=js"
export * from "./InventoryShort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports